var render, staticRenderFns
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca6ca4c')) {
      api.createRecord('0ca6ca4c', component.options)
    } else {
      api.reload('0ca6ca4c', component.options)
    }
    
  }
}
component.options.__file = "tmp/tmp-2mD2ZaraIB5lp/JS/carousel.vue"
export default component.exports